
































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditGasthreshold from './edit-gasthreshold.vue';
import CreateGasthreshold from './create-gasthreshold.vue';
class PageGasthresholdRequest extends PageRequest { 
  tName: string;
  gas_type:Number;
}
@Component({
  components: { EditGasthreshold, CreateGasthreshold },
})
export default class Floors extends AbpBase {
  pagerequest: PageGasthresholdRequest = new PageGasthresholdRequest();
  publicpagerequest: PageGasthresholdRequest = new PageGasthresholdRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  searchInt:number = 0;
  get list() {
    return this.$store.state.gasthreshold.list;
  }
  get loading() {
    return this.$store.state.gasthreshold.loading;
  }
  pageChange(page: number) {
    this.$store.commit("gasthreshold/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("gasthreshold/setPageSize", pagesize);
    this.getPage();
  }
  getsearch(){
    this.searchInt = 1;
    this.getPage();
  }
  async getPage() {
    if(this.searchInt == 1){
      this.$store.state.gasthreshold.currentPage=1;
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = 0;
      this.searchInt = 0;
    }
    else{
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    }
    
    //filters
    await this.$store.dispatch({
      type: "gasthreshold/getPage",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.gasthreshold.pageSize;
  }
  get totalCount() {
    return this.$store.state.gasthreshold.totalCount;
  }
  get currentPage() {
    return this.$store.state.gasthreshold.currentPage;
  }
    userName() {
    //console.log(this.$store.state.session.user);
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
  }
    companylist() {
     
    return this.$store.state.company.list;
  }
  columns = [
     {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "阈值方案",
      key: "tName",
    },
    {
      title: "氧气最高浓度",
      key: "maxoxygen",
    },
    {
      title: "氧气最低浓度",
      key: "minoxygen",
    },
    {
      title: "二氧化碳最高浓度",
      key: "maxcarbondioxide",
    },
    {
      title: "氮气最高浓度",
      key: "maxnitrogen",
    },
    {
      title: "磷化氢最高浓度",
      key: "maxchlorinehydride",
    },
    // {
    //   title: "一氧化碳最高浓度",
    //   key: "maxcarbonicoxide",
    // },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("gasthreshold/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "gasthreshold/delete",
                        data: params.row,
                      });
                      await this.getPage();
                    },
                  });
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];
   async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
      data: this.publicpagerequest,
    });
  }
  created() {
      this.publicpagerequest.maxResultCount = 99;
    this.publicpagerequest.skipCount = 0;
     if (this.userName() !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    }else{
      this.getcompany();
    }
    this.getPage();
  }
}
